
import { Backdrop, Box, Slide, Typography, getContrastRatio } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import CustomInput from './CustomInput';
import CustomAutocomplete from './CustomAutoComplete';
import { updateCreationState } from '../../../redux/eventCreationSlice';
import CheckIcon from '../../../components/icons/CheckIcon';
import DateTimePicker from '../../../components/date-time/DateTimePicker';
import { afterValidate, generateLighterContrastColor, isEventPending } from '../../../utils/commonServices';
import { getErrorMsg } from '../../../utils/validator';
import UpIcon from '../icons/UpIcon';
import DownIcon from '../icons/DownIcon';
// import { customTheme as theme } from '../../../theme/customTheme';
import useCustomTheme from '../../../theme/useCustomTheme';

const ProjectStartEndDatePage = (props) => {

    const {pageData, setPageData, slideDirection, nextPageHandler, prevPageHandler, pageIndex, selectedProjectType, setSelectedProjectType, totalScreens, closeHandler} = props
    const createEventReducer = useSelector((state) => state.createEventReducer);
    const [projectStartDateTime, setProjectStartDateTime] = useState(createEventReducer.edit !== true ? new Date() : new Date(pageData?.start_date * 1000))
    const [projectEndDateTime, setProjectEndDateTime] = useState(createEventReducer.edit !== true ? new Date() : new Date(pageData?.end_date * 1000))
    const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
    const dispatch = useDispatch()
    const [startDateValidationFlag, setStartDateValidationFlag] = useState(false);
    const [endDateValidationFlag, setEndDateValidationFlag] = useState(false);
    const [theme ] = useCustomTheme()

    const finishedHandler = ()=> {
      validateInputs(true)
      afterValidate(nextPageHandler);
    }

    const validateInputs = (flag) => {
      setStartDateValidationFlag(flag)
      setEndDateValidationFlag(flag)
    }

    useEffect(() => {
      const keyDownHandler = (event) => {
        // console.log("key Parent", event.key)
        if (event.key === "Enter") {
          event.preventDefault();
  
          finishedHandler();
        }
      };
        document.addEventListener("keydown", keyDownHandler)
        
      return () => {
        document.removeEventListener("keydown", keyDownHandler);
      };
    }, [pageData]);

  return (
    <>
    <Slide direction={slideDirection} in={true} mountOnEnter unmountOnExit>
    <Backdrop
    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 , backdropFilter: 'blur(18px) !important', display:'flex', flexDirection:'column', background: '#08231B88 0% 0% no-repeat padding-box', }}
    open={createEventReducer.open_backdrop_project_creation}
    >
        <Box sx={{ width:'100%', height:'100%', display:'flex', flexDirection:'column'}}>
          <Typography textAlign={'right'} sx={{fontSize:'16px', cursor:'pointer', mt:5, mr:3, fontFamily:'Rubik'}} onClick={closeHandler}>Close X</Typography>
          <Box flexGrow={1} className='flex col ' sx={{ paddingLeft:'14vw', marginTop:{xs:'20%',sm:'14%',md:'8%', lg:'7%'}}}>
              <Box mb={6}>
                <Typography sx={{fontSize:{xs:'15px',sm:'18px',md:'22px',lg:'24px',xl:'35px'}, color:'white', fontFamily:'Rubik',letterSpacing:'0.5px'}}>{`${pageIndex}/${totalScreens}`}</Typography>
                <Typography sx={{fontSize:{xs:'30px',sm:'35px',md:'40px',lg:'45px',xl:'65px'}, color:'white', fontFamily:'Rubik', letterSpacing:'0.5px'}}>When does filming start?</Typography>
                <Typography sx={{fontSize:{xs:'15px',sm:'18px',md:'22px',lg:'24px',xl:'35px'}, color:'white', fontFamily:'Rubik',letterSpacing:'0.5px'}}>Select the start date of your Lucihub video.</Typography>
              </Box>
              <Box className='flex' sx={{width:'68%'}} gap={1}>
                  <Box flex={1}>
                        <DateTimePicker 
                          placeholder='When does filming start?'
                          onFocus={() => {
                            setStartDateValidationFlag(false);
                            // setEndDateValidationFlag(true);
                          }}
                          disabled={createEventReducer.pageData?.start_date !="" && !isEventPending(createEventReducer.pageData?.start_date)}
                          onBlur={() => setStartDateValidationFlag(true)}
                          required = {createEventReducer.pageData?.start_date !="" ? isEventPending(createEventReducer.pageData?.start_date): true}
                          errorFlag={startDateValidationFlag && getErrorMsg("start_date_time", pageData?.start_date) != ""   }
                          errorMsg={getErrorMsg("start_date_time", pageData?.start_date)}
                          defaultValue={
                            pageData?.start_date != ""
                            ? new Date(pageData?.start_date * 1000)
                            : null
                          }
                          invalidDateMessage={null}
                          minDateMessage={null}
                          maxDateMessage={null}
                          label="Start date & time"
                          disablePast
                          animateYearScrolling
                          fullWidth
                          onDateChange={(date) => {
                            setPageData((last) => {
                            return {
                              ...last,
                              start_date: date
                             };
                           });
                          }}
                          dateTime={projectStartDateTime}
                          setDateTime={setProjectStartDateTime}
                          medium={true}
                         />
                </Box>
                {/* <Box flex={1}>
                
                    <DateTimePicker 
                    placeholder='When does filming end?'
                    onFocus={() => {
                      setStartDateValidationFlag(true);
                      setEndDateValidationFlag(false);
                    }}
                    onBlur={() => setEndDateValidationFlag(true)}
                    required
                    // right='0px'
                    errorFlag={
                      endDateValidationFlag &&
                      getErrorMsg(
                      "end_date_time",
                      pageData?.end_date,
                      pageData?.start_date
                      ) != ""
                    }
                    errorMsg={getErrorMsg(
                     "end_date_time",
                      pageData?.end_date,
                      pageData?.start_date
                    )}
                    disabled={pageData?.start_date === ""}
                    disablePast
                    label="End date & time"
                    defaultValue={
                      pageData?.end_date != ""
                      ? new Date(pageData?.end_date * 1000)
                      : null
                     }
                    onDateChange={(date) => {
                            setPageData((last) => {
                            return {
                              ...last,
                              end_date: date
                             };
                           });
                          }}
                    dateTime={projectEndDateTime}
                    setDateTime={setProjectEndDateTime}
                    medium={true}
                 />
                </Box> */}
                      <Box sx={{ pt:'2px'}}>
                        <CheckIcon  color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)} onClick={pageIndex !== 8 ? finishedHandler : null}  sx={{fontSize:{xs:'50px',xl:'60px'}, cursor: 'pointer'}}/>
                      </Box>
              </Box>
          </Box>
          <Box className='flex' sx={{justifyContent:'flex-end', mb:5, mr:5}}>
            {/* <Box className='flex a-center j-center' sx={{height:'40px', width:'40px', backgroundColor:'green', cursor:'pointer', opacity: pageIndex === 1 && 0.5}} onClick={pageIndex !== 1 ? prevPageHandler : null}>/\</Box> */}
            {/* <Box className='flex a-center j-center' sx={{height:'40px', width:'40px', backgroundColor:'green', cursor:'pointer',  opacity: pageIndex === 8 && 0.5}} onClick={pageIndex !== 8 ? finishedHandler : null}>\/</Box> */}
            <UpIcon  color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)} sx={{ cursor:'pointer', opacity: pageIndex === 1 && 0.5, fontSize:{xs:'45px', sm:'55px', lg:'65px',xl:'82px'}}} onClick={pageIndex !== 1 ? prevPageHandler : null}/>
            <DownIcon  color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)} sx={{ cursor:'pointer', fontSize:{xs:'45px', sm:'55px', lg:'65px',xl:'82px'}}} onClick={pageIndex !== 8 ? finishedHandler : null}/>
          </Box>
        </Box>
    </Backdrop>
    </Slide>
    </>
  )
}

export default ProjectStartEndDatePage

